function envOverride(): string | undefined {
	try {
		return process.env.BUN_PUBLIC_API_BASE_URL;
	} catch {
		return undefined;
	}
}

function resolveAPIBaseURL(): string {
	const override = envOverride();
	if (override) return override;
	if (typeof window !== "undefined") {
		const { protocol, hostname, port } = window.location;
		if (port && port !== "80" && port !== "443") {
			return `${protocol}//${hostname}:8080/api/v1`;
		}
	}
	return "/api/v1";
}

const apiBaseURL = resolveAPIBaseURL();

export default {
	api: {
		baseURL: apiBaseURL,
	},
};
